import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { removeItem, updateObjectInArray } from "./helpers";

export default function usersReducer(state = initialState.users, action) {
  switch (action.type) {
    case types.LOAD_USERS_SUCCESS:
      return action.users;
    case types.DELETE_USER_SUCCESS:
      return removeItem(state, action.user);
    case types.BLOCK_USER_SUCCESS:
      return updateObjectInArray(state, action.user);
    case types.UPDATE_USERS_SUCCESS:
      return updateObjectInArray(state, action.user);
    default:
      return state;
  }
}
